import { render } from "./VueAvatar.vue?vue&type=template&id=6b0e4617"
import script from "./VueAvatar.vue?vue&type=script&lang=js"
export * from "./VueAvatar.vue?vue&type=script&lang=js"
script.render = render

export default script